import React, { useEffect, useState } from "react";
import { Box, Typography, Button } from "@mui/material";
import { black, neutral400, primary500, white } from "../../lib/rebrandColors/colors";
import { fetchTotalCostSavings } from "../../functions/savings";
import TextButton from "../textButton";
import CustomIcon from "../icon";
import IconButton from "../iconButton";
import CustomButton from "../customButton";
import { useLocation } from 'react-router-dom';
import { handleBuildingDelete } from "../../functions/buildings";

const BuildingCard = ({
  building,
  layoutProps,
  onDetailsClick,
}) => {
  // NOTE: Filter Savings based on outlets in building
  const buildingSavingsArr = building?.devices?.length > 0 ? layoutProps.savings.filter(outlet => building?.devices.includes(outlet.outletID)) : [];
  const buildingLifetimeCostSavings = buildingSavingsArr.reduce((sum, item) => sum + item.costSavings, 0).toFixed(2);
  const location = useLocation();
  const [deleteOpen, setDeleteOpen] = useState(false);
  const onDeletePress = async () => {
    await handleBuildingDelete(building, layoutProps);
    layoutProps.setRefresh(prev => !prev);
    setDeleteOpen(false);
  };

  return (
    <Box sx={{
      width: location.pathname !== '/' ? '250px' : "160px",
      height: location.pathname !== '/' ? '350px' : "260px",
      borderRadius: "16px",
      boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
      backgroundColor: white,
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      textAlign: "center",
    }}>
      {location.pathname !== '/' &&
        <div style={{
          marginTop: '5px',
          width: '100%',
          display: 'flex',
          justifyContent: 'end',
          marginRight: '10px'
        }}>
          <IconButton
            iconName='cancel-1'
            size={20}
            onClick={() => setDeleteOpen(true)}
          />
        </div>
      }
      {/* Building Name */}
      <Typography sx={{
        color: "#1F1F1F",
        fontSize: location.pathname !== '/' ? '20px' : "14px",
        fontWeight: "400",
        marginTop: location.pathname !== '/' ? '20px' : "12px",
        marginBottom: location.pathname !== '/' ? '20px' : "12px",
      }}>
        {building.name}
      </Typography>

      {/* Building Image */}
      {/* Custom Building Icon */}
      <Box sx={{
        width: "100px",
        height: "100px",
        borderRadius: "50%",
        backgroundColor: "#f0f0f0",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}>
        <CustomIcon
          name="building-1"
          color={black}
          size={64}
          strokeWidth="1.5"
        />
      </Box>

      {/* Savings */}
      <Box sx={{
        width: "80%",
        backgroundColor: primary500,
        padding: "2px",
        borderRadius: "12px",
        marginTop: location.pathname !== '/' ? '16px' : "8px",
        marginBottom: location.pathname !== '/' ? '20px' : "12px",
      }}>
        <Typography sx={{
          color: white,
          fontSize: location.pathname !== '/' ? '16px' : "10px",
          fontWeight: "400",
        }}>
          Lifetime Cost Savings
        </Typography>
        <Typography sx={{
          color: white,
          fontSize: location.pathname !== '/' ? '20px' : "14px",
          fontWeight: "600",
        }}>
          {`$${buildingLifetimeCostSavings}`}
        </Typography>
      </Box>

      {/* Details Button */}
      <TextButton
        label="Details"
        onPress={onDetailsClick}
        fill={"#8E8E8E"}
        fontSize={location.pathname !== '/' ? '20px' : '14px'}
        underlined={true}
        iconPosition={"left"}
      />
      {deleteOpen &&
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}>
          <div style={{
            backgroundColor: 'white',
            padding: '20px',
            borderRadius: '10px',
            boxShadow: '0 2px 10px rgba(0,0,0,0.2)',
            textAlign: 'center',
            width: '400px'
          }}>
            <div className="labelLarge">
              Are you sure you want to delete this building, {building?.name}?
            </div>
            <div style={{
              display: 'flex',
              justifyContent: 'space-evenly',
              marginTop: '20px'
            }}>
              <CustomButton
                filled={true}
                label="Yes, Delete"
                onClick={onDeletePress}
                size="small"
              />
              <CustomButton
                filled={false}
                label="Cancel"
                onClick={() => setDeleteOpen(false)}
                size="small"
              />
            </div>
          </div>
        </div>
      }
    </Box>
  );
};

export default BuildingCard;
